export default __webpack_public_path__ + "static/media/statistics.5ff599df.png";